import React from 'react';

export const BrokenGlassIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_4081_47655)">
      <path
        d="M22.75 0H5.25C2.35051 0 0 2.35051 0 5.25V22.75C0 25.6495 2.35051 28 5.25 28H22.75C25.6495 28 28 25.6495 28 22.75V5.25C28 2.35051 25.6495 0 22.75 0Z"
        fill="#DAE4FC"
      />
      <path d="M15.5 13.4644L19.5 9.46436" stroke="#ADC4FB" strokeWidth="1.25" strokeLinecap="round" />
      <path d="M15.5 13.4644H19.5" stroke="#ADC4FB" strokeWidth="1.25" strokeLinecap="round" />
      <path d="M15.5 13.4644L19.5 17.4644" stroke="#ADC4FB" strokeWidth="1.25" strokeLinecap="round" />
      <path d="M13.937 10.1213L16.8158 15.4263" stroke="#ADC4FB" strokeWidth="1.25" strokeLinecap="round" />
      <path d="M15.5 13.4644L11.5 11.4644" stroke="#ADC4FB" strokeWidth="1.25" strokeLinecap="round" />
      <path d="M15.5 13.4644L13.5 16.4644" stroke="#ADC4FB" strokeWidth="1.25" strokeLinecap="round" />
      <path d="M15.5 13.4644L17.5 18.4644" stroke="#ADC4FB" strokeWidth="1.25" strokeLinecap="round" />
      <path
        d="M19.4375 7H8.5625C8.25184 7 8 7.25184 8 7.5625V19.9375C8 20.2482 8.25184 20.5 8.5625 20.5H19.4375C19.7482 20.5 20 20.2482 20 19.9375V7.5625C20 7.25184 19.7482 7 19.4375 7Z"
        stroke="#5B8DEE"
        strokeWidth="1.28571"
      />
    </g>
    <defs>
      <clipPath id="clip0_4081_47655">
        <rect width="28" height="28" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const BrokenPoleIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M22.75 0H5.25C2.35051 0 0 2.35051 0 5.25V22.75C0 25.6495 2.35051 28 5.25 28H22.75C25.6495 28 28 25.6495 28 22.75V5.25C28 2.35051 25.6495 0 22.75 0Z"
      fill="#DAE4FC"
    />
    <path d="M11.1467 7.76001H14.9511" stroke="#DAE4FC" strokeWidth="1.2" strokeLinecap="round" />
    <path d="M11.1467 8.70972H13.4293" stroke="#DAE4FC" strokeWidth="1.2" strokeLinecap="round" />
    <path
      d="M13.4294 9.65967H12.6685C12.4584 9.65967 12.2881 9.86379 12.2881 10.1156V13.763C12.2881 14.0148 12.4584 14.2189 12.6685 14.2189H13.4294C13.6395 14.2189 13.8098 14.0148 13.8098 13.763V10.1156C13.8098 9.86379 13.6395 9.65967 13.4294 9.65967Z"
      fill="#82A7F0"
    />
    <path
      d="M10.432 7.24436L9.89401 7.73282C9.74544 7.86771 9.77135 8.10992 9.95189 8.27383L12.567 10.6481C12.7476 10.812 13.0144 10.8355 13.1629 10.7006L13.7009 10.2122C13.8495 10.0773 13.8236 9.83508 13.6431 9.67117L11.0279 7.29691C10.8474 7.133 10.5806 7.10948 10.432 7.24436Z"
      fill="#82A7F0"
    />
    <path d="M16.0924 13.8389L18.375 16.1185" stroke="#5B8DEE" strokeLinecap="round" />
    <path d="M18.375 13.8389L16.0924 16.1185" stroke="#5B8DEE" strokeLinecap="round" />
    <path
      d="M13.4293 14.5987L13.0489 13.8389L12.6685 14.5987"
      stroke="#82A7F0"
      strokeWidth="0.5"
      strokeLinecap="round"
    />
    <path
      d="M13.4293 16.4984L13.0489 17.2583L12.6685 16.4984"
      stroke="#82A7F0"
      strokeWidth="0.5"
      strokeLinecap="round"
    />
    <path
      d="M13.4294 16.8784H12.6685C12.4584 16.8784 12.2881 17.0485 12.2881 17.2584V21.0577C12.2881 21.2675 12.4584 21.4376 12.6685 21.4376H13.4294C13.6395 21.4376 13.8098 21.2675 13.8098 21.0577V17.2584C13.8098 17.0485 13.6395 16.8784 13.4294 16.8784Z"
      fill="#82A7F0"
    />
  </svg>
);

export const FadedAdsIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M22.75 0H5.25C2.35051 0 0 2.35051 0 5.25V22.75C0 25.6495 2.35051 28 5.25 28H22.75C25.6495 28 28 25.6495 28 22.75V5.25C28 2.35051 25.6495 0 22.75 0Z"
      fill="#DAE4FC"
    />
    <path
      d="M18.8562 8H9.51875C9.23225 8 9 8.23225 9 8.51875V14.7438C9 15.0302 9.23225 15.2625 9.51875 15.2625H18.8562C19.1427 15.2625 19.375 15.0302 19.375 14.7438V8.51875C19.375 8.23225 19.1427 8 18.8562 8Z"
      stroke="#6995F9"
      strokeWidth="1.55625"
    />
    <path opacity="0.4" d="M11 10L14 13" stroke="#6995F9" strokeWidth="1.16719" strokeLinecap="round" />
    <path opacity="0.4" d="M13.15 10.075L15.225 12.15" stroke="#6995F9" strokeWidth="1.16719" strokeLinecap="round" />
    <path opacity="0.4" d="M15.225 10.075L17.3 12.15" stroke="#6995F9" strokeWidth="1.16719" strokeLinecap="round" />
    <path opacity="0.4" d="M11 12L12 13" stroke="#6995F9" strokeWidth="1.16719" strokeLinecap="round" />
    <path
      d="M14.7063 15.2625H13.6688C13.3823 15.2625 13.15 15.4947 13.15 15.7812V19.9312C13.15 20.2177 13.3823 20.45 13.6688 20.45H14.7063C14.9928 20.45 15.225 20.2177 15.225 19.9312V15.7812C15.225 15.4947 14.9928 15.2625 14.7063 15.2625Z"
      fill="#6995F9"
    />
  </svg>
);

export const GarbageOverflowIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="28" height="28" rx="6" fill="#DAE4FC" />
    <path
      d="M14.2165 6.86838L15.3492 8.00669C15.5719 7.94697 15.6408 7.68979 15.6984 7.48742C15.7427 7.44808 16.262 7.40802 16.3315 7.43964L17.3602 8.49856L17.4734 8.53861C17.5387 8.60466 17.3054 8.62082 17.3061 8.67774H18.9623C18.9813 8.67774 19.1401 8.75714 19.1696 8.77681C19.594 9.06701 19.4738 9.64039 19.2497 10.0219C19.1949 10.1154 18.9876 10.3754 18.8794 10.3754H18.4198C18.3847 10.8335 18.3868 11.2945 18.3636 11.7533C18.2231 14.5513 18.1086 17.3612 17.9455 20.1593C17.9238 20.5359 18.0474 21.0748 17.5162 21.1219C15.2691 21.105 13.015 21.1493 10.7721 21.0994C10.602 21.0299 10.5093 20.9013 10.4861 20.7172L9.95697 10.3761H9.49742C9.42575 10.3761 9.24166 10.2138 9.19317 10.1512C8.93389 9.81746 8.76314 9.12323 9.13555 8.81686C9.17842 8.78173 9.36884 8.67774 9.41381 8.67774H10.3743C10.3476 8.42408 10.3519 8.20695 10.1888 7.99615L10.5556 7.50921H12.1704C12.1781 7.50921 12.2245 7.43824 12.2125 7.52326C12.1978 7.62866 12.1022 7.72493 12.1289 7.84297C12.287 7.87389 12.4008 7.78044 12.5463 7.75936C12.5041 8.06501 12.5203 8.37489 12.4353 8.67774H12.8386C12.8913 8.61098 12.9053 8.53158 12.9524 8.4571C12.9918 8.39386 13.1794 8.17533 13.1836 8.15706C13.2026 8.08539 13.114 8.04393 13.0754 7.99545C13.0754 7.97226 13.2672 7.82822 13.2827 7.78816C13.2981 7.74811 13.2518 7.63217 13.2827 7.5345C13.3059 7.46143 13.4197 7.38343 13.4703 7.30473C13.5413 7.19512 13.5869 7.05458 13.6066 6.926L14.0099 6.89648L14.0774 6.86768H14.2165V6.86838ZM15.1138 8.15496C15.0161 8.24279 15.3077 8.46272 15.371 8.31657C15.3836 8.28706 15.3344 8.10717 15.385 8.03691C15.3253 8.09312 15.1574 8.1149 15.1138 8.15496ZM17.5563 10.3761H10.7924L10.8922 10.8511H17.4003L17.5563 10.3761Z"
      fill="#6995F9"
    />
    <path
      d="M21.3703 19.394C21.3064 19.4158 21.0513 19.486 21.0661 19.571C21.1314 19.6779 21.2537 19.7067 21.3591 19.7537C21.3851 19.7657 21.4076 19.7376 21.3977 19.7973C21.3788 19.843 20.9389 20.195 20.8665 20.2407C20.7942 20.2864 20.4948 20.4128 20.4773 20.4353C20.3901 20.5463 20.5321 20.6447 20.5075 20.6749C20.3536 20.6026 20.251 20.5997 20.1315 20.7304C20.0114 20.4817 19.8175 20.5449 19.5877 20.4951C19.4085 20.4564 18.8864 20.3517 18.8429 20.1536C18.7909 19.9196 19.0199 19.6483 19.1689 19.4881L19.0614 19.3286C19.093 19.2647 19.2356 19.1825 19.2504 19.1235C19.2666 19.0616 19.216 19.0082 19.2385 18.9211C19.2813 18.7539 19.6256 18.5416 19.5617 18.2817C19.7739 18.276 19.9882 18.1931 20.2004 18.2395L21.3696 19.394H21.3703Z"
      fill="#6995F9"
    />
  </svg>
);

export const GoodConditionIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="28" height="28" rx="6" fill="#DAE4FC" />
    <path
      d="M14.4071 6.64001C18.4248 6.95032 21.1046 10.9919 19.7043 14.857C19.2482 16.1173 18.3804 17.1687 17.2757 17.9089L17.271 21.2521C17.2379 21.5681 16.9178 21.7674 16.6204 21.6421L13.9888 20.3335L11.4375 21.6146C11.1372 21.7807 10.7859 21.6127 10.7283 21.2787L10.7208 17.9089C7.90978 16.0736 7.05996 12.31 8.88234 9.44419C9.89268 7.85658 11.7018 6.76148 13.5884 6.64001H14.4071ZM13.6696 8.52844C10.4073 8.77138 8.65856 12.5729 10.5952 15.2423C12.2769 17.5597 15.7403 17.5521 17.4107 15.2252C19.5069 12.3043 17.2294 8.26368 13.6696 8.52844Z"
      fill="#6995F9"
    />
    <path
      d="M14.3503 9.97257C14.6131 10.2084 14.8002 10.9855 15.0522 11.2843C15.5128 11.4093 16.0692 11.3745 16.523 11.4873C16.8458 11.5671 17.0068 11.9336 16.7605 12.1864L15.7163 13.1241C15.726 13.5423 15.9083 13.9905 15.9471 14.4011C15.9859 14.8117 15.7813 14.9837 15.3731 14.9574L13.9877 14.2959L12.7187 14.9292C12.2892 15.0391 12.0129 14.838 12.0545 14.4011C12.0933 13.9867 12.2746 13.5451 12.2853 13.1241L11.2101 12.1582C11.0046 11.8894 11.1752 11.5747 11.4787 11.4873L12.9494 11.2843C13.0522 11.2167 13.4167 10.3052 13.5447 10.1163C13.7308 9.84196 14.0827 9.73202 14.3503 9.97257Z"
      fill="#6995F9"
    />
  </svg>
);

export const GraffitiIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="28" height="28" rx="6" fill="#DAE4FC" />
    <path
      d="M8.12106 20.7571C7.95051 20.6526 7.86593 20.5666 7.8479 20.3534V13.4542C7.88256 13.0491 8.01498 12.6788 8.20702 12.3292L13.1668 12.3235C13.2694 12.4891 13.3575 12.6625 13.4233 12.848C13.4642 12.9645 13.5662 13.2637 13.5662 13.3717V14.8656H10.585C10.4935 14.8656 10.2703 15.0987 10.2737 15.2167C10.3306 16.0474 10.1926 16.9969 10.2709 17.8135C10.2786 17.8952 10.316 18.0132 10.3694 18.0757C10.3895 18.0992 10.5718 18.2171 10.585 18.2171H13.5662V20.4373C13.5662 20.4487 13.4733 20.6164 13.458 20.6334C13.4039 20.6931 13.318 20.6974 13.2667 20.7585H8.12106V20.7571Z"
      fill="#6995F9"
    />
    <path
      d="M21.7873 10.0629C21.7152 10.7998 21.1973 11.4849 20.5408 11.7728C20.3258 13.1891 18.5593 13.7001 17.6622 12.5765C17.4147 12.2667 17.3301 11.917 17.2684 11.529C16.3269 11.1218 15.4146 10.4573 14.3878 10.2945C14.0689 10.2441 13.5482 10.3187 13.5628 9.8255C13.5767 9.35787 14.0724 9.43462 14.3878 9.38488C15.4125 9.22355 16.3283 8.55623 17.2684 8.15043C17.4216 6.07525 20.147 5.84072 20.5408 7.90667C21.198 8.19378 21.7159 8.87816 21.7873 9.61656C21.7984 9.7324 21.7984 9.94773 21.7873 10.0636V10.0629Z"
      fill="#6995F9"
    />
    <path
      d="M12.7488 11.4869H8.63831V10.5516C8.63831 10.5396 8.73883 10.3619 8.76032 10.3413C8.80747 10.2965 8.93919 10.2382 9.00506 10.2297C10.0776 10.3121 11.3012 10.1224 12.3557 10.229C12.4389 10.2375 12.5658 10.2823 12.6275 10.3413C12.649 10.3612 12.7495 10.5389 12.7495 10.5516V11.4869H12.7488Z"
      fill="#6995F9"
    />
    <path
      d="M11.932 9.39264H9.45483V8.45739C9.45483 8.44531 9.55536 8.26764 9.57685 8.24703C9.63856 8.18804 9.76543 8.14327 9.84862 8.13474C10.3963 8.07931 11.0335 8.17738 11.5909 8.13759C11.6408 8.1454 11.7746 8.21221 11.8113 8.24703C11.8328 8.26693 11.9333 8.4446 11.9333 8.45739V9.39264H11.932Z"
      fill="#6995F9"
    />
    <path d="M13.3621 15.225H10.7672V17.885H13.3621V15.225Z" fill="#6995F9" />
  </svg>
);

export const LightsOutIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="28" height="28" rx="6" fill="#DAE4FC" />
    <path
      d="M14.1336 7.40628C17.4931 7.15208 20.0513 10.2962 19.1626 13.5351C18.8643 14.623 18.1749 15.2617 17.5825 16.1697L10.717 9.32571C10.6987 9.22984 11.2954 8.63743 11.4031 8.54372C12.1355 7.91038 13.1653 7.47953 14.1325 7.40521L14.1336 7.40628Z"
      fill="#6995F9"
    />
    <path
      d="M17.1591 17.2705L17.0783 17.7122L11.9749 17.7057C11.8694 16.9754 11.6152 16.3087 11.1908 15.7066C11.04 15.4922 10.8504 15.3059 10.6996 15.098C9.64622 13.6514 9.45126 11.8742 10.1428 10.2176L7.39504 7.46016C7.12469 7.20596 7.37458 6.78912 7.69448 7.0347L20.5887 19.9267C20.7481 20.2057 20.4045 20.4599 20.1815 20.2402L17.2539 17.3179L17.1591 17.2716V17.2705Z"
      fill="#6995F9"
    />
    <path
      d="M17.0643 18.2141C17.1171 18.7171 16.7789 19.1803 16.2802 19.2686C15.1998 19.2374 14.0311 19.358 12.9594 19.2837C12.3713 19.2427 11.9501 18.8162 12.0018 18.213H17.0643V18.2141Z"
      fill="#6995F9"
    />
    <path d="M16.1521 19.7866C15.7697 21.4626 13.3096 21.4529 12.9132 19.7866H16.1521Z" fill="#6995F9" />
  </svg>
);

export const OtherIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M22.75 0H5.25C2.35051 0 0 2.35051 0 5.25V22.75C0 25.6495 2.35051 28 5.25 28H22.75C25.6495 28 28 25.6495 28 22.75V5.25C28 2.35051 25.6495 0 22.75 0Z"
      fill="#DAE4FC"
    />
    <path
      d="M14 13.5625C14.7249 13.5625 15.3125 12.9749 15.3125 12.25C15.3125 11.5251 14.7249 10.9375 14 10.9375C13.2751 10.9375 12.6875 11.5251 12.6875 12.25C12.6875 12.9749 13.2751 13.5625 14 13.5625Z"
      fill="#6995F9"
    />
    <path
      d="M17.0625 17.0625C17.7874 17.0625 18.375 16.4749 18.375 15.75C18.375 15.0251 17.7874 14.4375 17.0625 14.4375C16.3376 14.4375 15.75 15.0251 15.75 15.75C15.75 16.4749 16.3376 17.0625 17.0625 17.0625Z"
      fill="#6995F9"
    />
    <path
      d="M10.9375 17.0625C11.6624 17.0625 12.25 16.4749 12.25 15.75C12.25 15.0251 11.6624 14.4375 10.9375 14.4375C10.2126 14.4375 9.625 15.0251 9.625 15.75C9.625 16.4749 10.2126 17.0625 10.9375 17.0625Z"
      fill="#6995F9"
    />
  </svg>
);

export const PersonalPropertyIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_4080_47533)">
      <path
        d="M22.75 0H5.25C2.35051 0 0 2.35051 0 5.25V22.75C0 25.6495 2.35051 28 5.25 28H22.75C25.6495 28 28 25.6495 28 22.75V5.25C28 2.35051 25.6495 0 22.75 0Z"
        fill="#DAE4FC"
      />
      <path
        d="M18.9 11.2H10.1C9.49249 11.2 9 11.6924 9 12.3V18.9C9 19.5075 9.49249 20 10.1 20H18.9C19.5075 20 20 19.5075 20 18.9V12.3C20 11.6924 19.5075 11.2 18.9 11.2Z"
        fill="#6995F9"
      />
      <path
        d="M12.3 11.2C12.3 9.73333 13.0334 9 14.5 9C15.9667 9 16.7 9.73333 16.7 11.2"
        stroke="#6995F9"
        strokeWidth="1.51"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4080_47533">
        <rect width="28" height="28" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SignMissingFadedIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="28" height="28" rx="6" fill="#DAE4FC" />
    <path
      d="M14.1875 7.2807C14.5647 7.32862 14.89 7.47845 15.102 7.80441C15.4603 8.35445 15.2761 9.05903 14.7247 9.39107V19.8869H15.7323C15.8517 19.8869 16.0778 20.0725 16.1365 20.1811C16.3701 20.6124 16.0319 21.0443 15.5717 21.0436C14.6579 20.9937 13.68 21.1071 12.7743 21.0436C12.6811 21.0369 12.5651 21.0214 12.478 20.9903C12.0346 20.8317 11.9826 20.2176 12.3815 19.9766C12.4105 19.9591 12.5711 19.8862 12.5867 19.8862H13.5943V9.39039C13.0429 9.05903 12.8593 8.35445 13.217 7.80374C13.4053 7.51489 13.7839 7.28948 14.1315 7.28003H14.1855L14.1875 7.2807Z"
      fill="#6995F9"
    />
    <path
      d="M7.28003 11.6079C7.3185 11.5634 7.32322 11.5094 7.36034 11.4594C7.52299 11.2414 7.88 10.9431 8.08719 10.7346C8.18572 10.6354 8.43813 10.2905 8.58391 10.2905H12.8708V12.9246H8.55691C8.23702 12.6911 7.9178 12.4056 7.62894 12.1323C7.50477 12.0142 7.36641 11.888 7.28003 11.7422V11.6079Z"
      fill="#6995F9"
    />
    <path
      d="M15.4508 15.9887V13.3951L15.4913 13.3546H19.7107C19.7302 13.3546 19.8457 13.416 19.872 13.4349C20.0717 13.578 20.7406 14.2637 20.9072 14.4695C21.0503 14.6457 21.1043 14.7921 20.9336 14.9804C20.7149 15.222 20.2526 15.627 19.9935 15.8409C19.9293 15.8935 19.8592 15.9408 19.7917 15.9887H15.4508Z"
      fill="#6995F9"
    />
  </svg>
);

export const BrokenGlassIconV2: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M15.5 13.4644L19.5 9.46436" stroke="#ADC4FB" strokeWidth="1.25" strokeLinecap="round" />
    <path d="M15.5 13.4644H19.5" stroke="#ADC4FB" strokeWidth="1.25" strokeLinecap="round" />
    <path d="M15.5 13.4644L19.5 17.4644" stroke="#ADC4FB" strokeWidth="1.25" strokeLinecap="round" />
    <path d="M13.937 10.1213L16.8158 15.4263" stroke="#ADC4FB" strokeWidth="1.25" strokeLinecap="round" />
    <path d="M15.5 13.4644L11.5 11.4644" stroke="#ADC4FB" strokeWidth="1.25" strokeLinecap="round" />
    <path d="M15.5 13.4644L13.5 16.4644" stroke="#ADC4FB" strokeWidth="1.25" strokeLinecap="round" />
    <path d="M15.5 13.4644L17.5 18.4644" stroke="#ADC4FB" strokeWidth="1.25" strokeLinecap="round" />
    <path
      d="M19.4375 7H8.5625C8.25184 7 8 7.25184 8 7.5625V19.9375C8 20.2482 8.25184 20.5 8.5625 20.5H19.4375C19.7482 20.5 20 20.2482 20 19.9375V7.5625C20 7.25184 19.7482 7 19.4375 7Z"
      stroke="#5B8DEE"
      strokeWidth="1.28571"
    />
  </svg>
);

export const BrokenPoleIconV2: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M13.4294 9.65967H12.6685C12.4584 9.65967 12.2881 9.86379 12.2881 10.1156V13.763C12.2881 14.0148 12.4584 14.2189 12.6685 14.2189H13.4294C13.6395 14.2189 13.8098 14.0148 13.8098 13.763V10.1156C13.8098 9.86379 13.6395 9.65967 13.4294 9.65967Z"
      fill="#82A7F0"
    />
    <path
      d="M10.432 7.24436L9.89401 7.73282C9.74544 7.86771 9.77135 8.10992 9.95189 8.27383L12.567 10.6481C12.7476 10.812 13.0144 10.8355 13.1629 10.7006L13.7009 10.2122C13.8495 10.0773 13.8236 9.83508 13.6431 9.67117L11.0279 7.29691C10.8474 7.133 10.5806 7.10948 10.432 7.24436Z"
      fill="#82A7F0"
    />
    <path d="M16.0924 13.8389L18.375 16.1185" stroke="#5B8DEE" strokeLinecap="round" />
    <path d="M18.375 13.8389L16.0924 16.1185" stroke="#5B8DEE" strokeLinecap="round" />
    <path
      d="M13.4293 14.5987L13.0489 13.8389L12.6685 14.5987"
      stroke="#82A7F0"
      strokeWidth="0.5"
      strokeLinecap="round"
    />
    <path
      d="M13.4293 16.4984L13.0489 17.2583L12.6685 16.4984"
      stroke="#82A7F0"
      strokeWidth="0.5"
      strokeLinecap="round"
    />
    <path
      d="M13.4294 16.8784H12.6685C12.4584 16.8784 12.2881 17.0485 12.2881 17.2584V21.0577C12.2881 21.2675 12.4584 21.4376 12.6685 21.4376H13.4294C13.6395 21.4376 13.8098 21.2675 13.8098 21.0577V17.2584C13.8098 17.0485 13.6395 16.8784 13.4294 16.8784Z"
      fill="#82A7F0"
    />
  </svg>
);

export const FadedAdsIconV2: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M18.8562 8H9.51875C9.23225 8 9 8.23225 9 8.51875V14.7438C9 15.0302 9.23225 15.2625 9.51875 15.2625H18.8562C19.1427 15.2625 19.375 15.0302 19.375 14.7438V8.51875C19.375 8.23225 19.1427 8 18.8562 8Z"
      stroke="#6995F9"
      strokeWidth="1.55625"
    />
    <path opacity="0.4" d="M11 10L14 13" stroke="#6995F9" strokeWidth="1.16719" strokeLinecap="round" />
    <path opacity="0.4" d="M13.15 10.075L15.225 12.15" stroke="#6995F9" strokeWidth="1.16719" strokeLinecap="round" />
    <path opacity="0.4" d="M15.225 10.075L17.3 12.15" stroke="#6995F9" strokeWidth="1.16719" strokeLinecap="round" />
    <path opacity="0.4" d="M11 12L12 13" stroke="#6995F9" strokeWidth="1.16719" strokeLinecap="round" />
    <path
      d="M14.7063 15.2625H13.6688C13.3823 15.2625 13.15 15.4947 13.15 15.7812V19.9312C13.15 20.2177 13.3823 20.45 13.6688 20.45H14.7063C14.9928 20.45 15.225 20.2177 15.225 19.9312V15.7812C15.225 15.4947 14.9928 15.2625 14.7063 15.2625Z"
      fill="#6995F9"
    />
  </svg>
);

export const GarbageOverflowIconV2: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M14.2165 6.86838L15.3492 8.00669C15.5719 7.94697 15.6408 7.68979 15.6984 7.48742C15.7427 7.44808 16.262 7.40802 16.3315 7.43964L17.3602 8.49856L17.4734 8.53861C17.5387 8.60466 17.3054 8.62082 17.3061 8.67774H18.9623C18.9813 8.67774 19.1401 8.75714 19.1696 8.77681C19.594 9.06701 19.4738 9.64039 19.2497 10.0219C19.1949 10.1154 18.9876 10.3754 18.8794 10.3754H18.4198C18.3847 10.8335 18.3868 11.2945 18.3636 11.7533C18.2231 14.5513 18.1086 17.3612 17.9455 20.1593C17.9238 20.5359 18.0474 21.0748 17.5162 21.1219C15.2691 21.105 13.015 21.1493 10.7721 21.0994C10.602 21.0299 10.5093 20.9013 10.4861 20.7172L9.95697 10.3761H9.49742C9.42575 10.3761 9.24166 10.2138 9.19317 10.1512C8.93389 9.81746 8.76314 9.12323 9.13555 8.81686C9.17842 8.78173 9.36884 8.67774 9.41381 8.67774H10.3743C10.3476 8.42408 10.3519 8.20695 10.1888 7.99615L10.5556 7.50921H12.1704C12.1781 7.50921 12.2245 7.43824 12.2125 7.52326C12.1978 7.62866 12.1022 7.72493 12.1289 7.84297C12.287 7.87389 12.4008 7.78044 12.5463 7.75936C12.5041 8.06501 12.5203 8.37489 12.4353 8.67774H12.8386C12.8913 8.61098 12.9053 8.53158 12.9524 8.4571C12.9918 8.39386 13.1794 8.17533 13.1836 8.15706C13.2026 8.08539 13.114 8.04393 13.0754 7.99545C13.0754 7.97226 13.2672 7.82822 13.2827 7.78816C13.2981 7.74811 13.2518 7.63217 13.2827 7.5345C13.3059 7.46143 13.4197 7.38343 13.4703 7.30473C13.5413 7.19512 13.5869 7.05458 13.6066 6.926L14.0099 6.89648L14.0774 6.86768H14.2165V6.86838ZM15.1138 8.15496C15.0161 8.24279 15.3077 8.46272 15.371 8.31657C15.3836 8.28706 15.3344 8.10717 15.385 8.03691C15.3253 8.09312 15.1574 8.1149 15.1138 8.15496ZM17.5563 10.3761H10.7924L10.8922 10.8511H17.4003L17.5563 10.3761Z"
      fill="#6995F9"
    />
    <path
      d="M21.3703 19.394C21.3064 19.4158 21.0513 19.486 21.0661 19.571C21.1314 19.6779 21.2537 19.7067 21.3591 19.7537C21.3851 19.7657 21.4076 19.7376 21.3977 19.7973C21.3788 19.843 20.9389 20.195 20.8665 20.2407C20.7942 20.2864 20.4948 20.4128 20.4773 20.4353C20.3901 20.5463 20.5321 20.6447 20.5075 20.6749C20.3536 20.6026 20.251 20.5997 20.1315 20.7304C20.0114 20.4817 19.8175 20.5449 19.5877 20.4951C19.4085 20.4564 18.8864 20.3517 18.8429 20.1536C18.7909 19.9196 19.0199 19.6483 19.1689 19.4881L19.0614 19.3286C19.093 19.2647 19.2356 19.1825 19.2504 19.1235C19.2666 19.0616 19.216 19.0082 19.2385 18.9211C19.2813 18.7539 19.6256 18.5416 19.5617 18.2817C19.7739 18.276 19.9882 18.1931 20.2004 18.2395L21.3696 19.394H21.3703Z"
      fill="#6995F9"
    />
  </svg>
);

export const GoodConditionIconV2: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M14.4072 6.63989C18.4249 6.9502 21.1047 10.9918 19.7044 14.8569C19.2483 16.1171 18.3806 17.1686 17.2758 17.9088L17.2711 21.252C17.238 21.568 16.9179 21.7672 16.6205 21.642L13.9889 20.3334L11.4376 21.6145C11.1373 21.7805 10.7861 21.6126 10.7285 21.2785L10.7209 17.9088C7.9099 16.0735 7.06009 12.3099 8.88247 9.44407C9.8928 7.85646 11.702 6.76136 13.5885 6.63989H14.4072ZM13.6698 8.52832C10.4074 8.77125 8.65868 12.5728 10.5953 15.2422C12.277 17.5596 15.7405 17.552 17.4108 15.2251C19.507 12.3042 17.2295 8.26356 13.6698 8.52832Z"
      fill="#6995F9"
    />
    <path
      d="M14.3502 9.97269C14.6129 10.2085 14.8 10.9856 15.0521 11.2844C15.5126 11.4094 16.0691 11.3746 16.5229 11.4874C16.8457 11.5673 17.0066 11.9337 16.7604 12.1865L15.7162 13.1242C15.7259 13.5424 15.9082 13.9906 15.947 14.4012C15.9857 14.8118 15.7812 14.9838 15.373 14.9575L13.9876 14.296L12.7185 14.9293C12.289 15.0392 12.0127 14.8381 12.0544 14.4012C12.0932 13.9868 12.2745 13.5452 12.2852 13.1242L11.21 12.1583C11.0045 11.8896 11.1751 11.5748 11.4785 11.4874L12.9493 11.2844C13.052 11.2168 13.4166 10.3053 13.5445 10.1165C13.7307 9.84208 14.0826 9.73215 14.3502 9.97269Z"
      fill="#6995F9"
    />
  </svg>
);

export const GraffitiIconV2: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M8.12106 20.7571C7.95051 20.6526 7.86593 20.5666 7.8479 20.3534V13.4542C7.88256 13.0491 8.01498 12.6788 8.20702 12.3292L13.1668 12.3235C13.2694 12.4891 13.3575 12.6625 13.4233 12.848C13.4642 12.9645 13.5662 13.2637 13.5662 13.3717V14.8656H10.585C10.4935 14.8656 10.2703 15.0987 10.2737 15.2167C10.3306 16.0474 10.1926 16.9969 10.2709 17.8135C10.2786 17.8952 10.316 18.0132 10.3694 18.0757C10.3895 18.0992 10.5718 18.2171 10.585 18.2171H13.5662V20.4373C13.5662 20.4487 13.4733 20.6164 13.458 20.6334C13.4039 20.6931 13.318 20.6974 13.2667 20.7585H8.12106V20.7571Z"
      fill="#6995F9"
    />
    <path
      d="M21.7873 10.0629C21.7152 10.7998 21.1973 11.4849 20.5408 11.7728C20.3258 13.1891 18.5593 13.7001 17.6622 12.5765C17.4147 12.2667 17.3301 11.917 17.2684 11.529C16.3269 11.1218 15.4146 10.4573 14.3878 10.2945C14.0689 10.2441 13.5482 10.3187 13.5628 9.8255C13.5767 9.35787 14.0724 9.43462 14.3878 9.38488C15.4125 9.22355 16.3283 8.55623 17.2684 8.15043C17.4216 6.07525 20.147 5.84072 20.5408 7.90667C21.198 8.19378 21.7159 8.87816 21.7873 9.61656C21.7984 9.7324 21.7984 9.94773 21.7873 10.0636V10.0629Z"
      fill="#6995F9"
    />
    <path
      d="M12.7488 11.4869H8.63831V10.5516C8.63831 10.5396 8.73883 10.3619 8.76032 10.3413C8.80747 10.2965 8.93919 10.2382 9.00506 10.2297C10.0776 10.3121 11.3012 10.1224 12.3557 10.229C12.4389 10.2375 12.5658 10.2823 12.6275 10.3413C12.649 10.3612 12.7495 10.5389 12.7495 10.5516V11.4869H12.7488Z"
      fill="#6995F9"
    />
    <path
      d="M11.932 9.39264H9.45483V8.45739C9.45483 8.44531 9.55536 8.26764 9.57685 8.24703C9.63856 8.18804 9.76543 8.14327 9.84862 8.13474C10.3963 8.07931 11.0335 8.17738 11.5909 8.13759C11.6408 8.1454 11.7746 8.21221 11.8113 8.24703C11.8328 8.26693 11.9333 8.4446 11.9333 8.45739V9.39264H11.932Z"
      fill="#6995F9"
    />
    <path d="M13.3621 15.225H10.7672V17.885H13.3621V15.225Z" fill="#6995F9" />
  </svg>
);

export const LightsOutIconV2: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M14.1336 7.40628C17.4931 7.15208 20.0513 10.2962 19.1626 13.5351C18.8643 14.623 18.1749 15.2617 17.5825 16.1697L10.717 9.32571C10.6987 9.22984 11.2954 8.63743 11.4031 8.54372C12.1355 7.91038 13.1653 7.47953 14.1325 7.40521L14.1336 7.40628Z"
      fill="#6995F9"
    />
    <path
      d="M17.1591 17.2705L17.0783 17.7122L11.9749 17.7057C11.8694 16.9754 11.6152 16.3087 11.1908 15.7066C11.04 15.4922 10.8504 15.3059 10.6996 15.098C9.64622 13.6514 9.45126 11.8742 10.1428 10.2176L7.39504 7.46016C7.12469 7.20596 7.37458 6.78912 7.69448 7.0347L20.5887 19.9267C20.7481 20.2057 20.4045 20.4599 20.1815 20.2402L17.2539 17.3179L17.1591 17.2716V17.2705Z"
      fill="#6995F9"
    />
    <path
      d="M17.0643 18.2141C17.1171 18.7171 16.7789 19.1803 16.2802 19.2686C15.1998 19.2374 14.0311 19.358 12.9594 19.2837C12.3713 19.2427 11.9501 18.8162 12.0018 18.213H17.0643V18.2141Z"
      fill="#6995F9"
    />
    <path d="M16.1521 19.7866C15.7697 21.4626 13.3096 21.4529 12.9132 19.7866H16.1521Z" fill="#6995F9" />
  </svg>
);

export const OtherIconV2: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M14 13.5625C14.7249 13.5625 15.3125 12.9749 15.3125 12.25C15.3125 11.5251 14.7249 10.9375 14 10.9375C13.2751 10.9375 12.6875 11.5251 12.6875 12.25C12.6875 12.9749 13.2751 13.5625 14 13.5625Z"
      fill="#6995F9"
    />
    <path
      d="M17.0625 17.0625C17.7874 17.0625 18.375 16.4749 18.375 15.75C18.375 15.0251 17.7874 14.4375 17.0625 14.4375C16.3376 14.4375 15.75 15.0251 15.75 15.75C15.75 16.4749 16.3376 17.0625 17.0625 17.0625Z"
      fill="#6995F9"
    />
    <path
      d="M10.9375 17.0625C11.6624 17.0625 12.25 16.4749 12.25 15.75C12.25 15.0251 11.6624 14.4375 10.9375 14.4375C10.2126 14.4375 9.625 15.0251 9.625 15.75C9.625 16.4749 10.2126 17.0625 10.9375 17.0625Z"
      fill="#6995F9"
    />
  </svg>
);

export const PersonalPropertyIconV2: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M18.9 11.2H10.1C9.49249 11.2 9 11.6924 9 12.3V18.9C9 19.5075 9.49249 20 10.1 20H18.9C19.5075 20 20 19.5075 20 18.9V12.3C20 11.6924 19.5075 11.2 18.9 11.2Z"
      fill="#6995F9"
    />
    <path
      d="M12.3 11.2C12.3 9.73333 13.0334 9 14.5 9C15.9667 9 16.7 9.73333 16.7 11.2"
      stroke="#6995F9"
      strokeWidth="1.51"
      strokeLinecap="round"
    />
  </svg>
);

export const SignMissingFadedIconV2: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M14.1875 7.2807C14.5647 7.32862 14.89 7.47845 15.102 7.80441C15.4603 8.35445 15.2761 9.05903 14.7247 9.39107V19.8869H15.7323C15.8517 19.8869 16.0778 20.0725 16.1365 20.1811C16.3701 20.6124 16.0319 21.0443 15.5717 21.0436C14.6579 20.9937 13.68 21.1071 12.7743 21.0436C12.6811 21.0369 12.5651 21.0214 12.478 20.9903C12.0346 20.8317 11.9826 20.2176 12.3815 19.9766C12.4105 19.9591 12.5711 19.8862 12.5867 19.8862H13.5943V9.39039C13.0429 9.05903 12.8593 8.35445 13.217 7.80374C13.4053 7.51489 13.7839 7.28948 14.1315 7.28003H14.1855L14.1875 7.2807Z"
      fill="#6995F9"
    />
    <path
      d="M7.28003 11.6079C7.3185 11.5634 7.32322 11.5094 7.36034 11.4594C7.52299 11.2414 7.88 10.9431 8.08719 10.7346C8.18572 10.6354 8.43813 10.2905 8.58391 10.2905H12.8708V12.9246H8.55691C8.23702 12.6911 7.9178 12.4056 7.62894 12.1323C7.50477 12.0142 7.36641 11.888 7.28003 11.7422V11.6079Z"
      fill="#6995F9"
    />
    <path
      d="M15.4508 15.9887V13.3951L15.4913 13.3546H19.7107C19.7302 13.3546 19.8457 13.416 19.872 13.4349C20.0717 13.578 20.7406 14.2637 20.9072 14.4695C21.0503 14.6457 21.1043 14.7921 20.9336 14.9804C20.7149 15.222 20.2526 15.627 19.9935 15.8409C19.9293 15.8935 19.8592 15.9408 19.7917 15.9887H15.4508Z"
      fill="#6995F9"
    />
  </svg>
);
